import React from "react";
import { Link } from "react-router-dom";

const JourneyBreadcrumb = ({ items = [], className = "" }) => {
  if (!items.length) return null;

  return (
    <nav
      aria-label="breadcrumb"
      className={`flex items-center gap-2 text-xs font-medium text-gray-500 ${className}`}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const content = isLast || !item.to ? (
          <span className="text-gray-700" aria-current="page">
            {item.label}
          </span>
        ) : (
          <Link
            to={item.to}
            className="rounded-lg border border-transparent px-2 py-1 text-gray-500 transition hover:border-secondary-green/40 hover:bg-secondary-green/10 hover:text-secondary-green"
          >
            {item.label}
          </Link>
        );

        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {index !== 0 && <span className="text-gray-400">›</span>}
            {content}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default JourneyBreadcrumb;

